import bonk1 from '../audio/bonks/bonk1.mp3';
import bonk2 from '../audio/bonks/bonk2.mp3';

import buttonclick1 from '../audio/misc/buttonclick1.mp3';
import buttonclick2 from '../audio/misc/buttonclick2.mp3';

import music1 from '../audio/music/music1.mp3';
import music2 from '../audio/music/music2.mp3';


const sounds = {
    bonks: [
        bonk1,
        bonk2
    ],
    buttonclicks: [
        buttonclick1,
        buttonclick2
    ],
    music: [
        music1,
        music2
    ]
}

export default sounds;